import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { config } from "@config";
import { ApicallService } from "@core-services/apicall.service";
import { Device } from "@modules/+new/core/device-redirection-guard/entities/device.model";
import { TransactionDeviceRemote } from "@modules/+new/core/device-redirection-guard/infrastructure/transaction-device.remote";
import { AuthGuard } from "@main-services/auth-guard.service";

@Injectable({
	providedIn: "root"
})
export class MobileRedirectionsGuard {
	constructor(
		private api: ApicallService,
		private usedDeviceRemote: TransactionDeviceRemote,
		private authGuard: AuthGuard
	) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.usedDeviceRemote.getUsedDevice$(route.params["fpid"]).pipe(
			map((device: Device) => this.isValidIOSDevice(device)),
			map((isIOSApp: boolean) => {
				if (isIOSApp) {
					this.redirectToIOSApp(state);
				}
				return !isIOSApp;
			}),
			switchMap((shouldStayInApp: boolean) => {
				if (shouldStayInApp) {
					return this.authGuard.canActivate(route, state);
				}
				return of(false);
			})
		);
	}

	private isValidIOSDevice(device: Pick<Device, "isApp" | "os">): boolean {
		return device.isApp && device.os.toLowerCase().includes("ios");
	}

	private redirectToIOSApp(state: RouterStateSnapshot): void {
		window.location.assign(`${config.iOSUrl}${state.url}`);
	}
}
